var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        "cancel-variant": "outline-secondary",
        centered: "",
        "ok-title": "저장",
        "cancel-title": "취소",
        size: "lg",
        title: "우선순위 설정",
        "no-close-on-esc": "",
        "no-close-on-backdrop": "",
      },
      on: {
        ok: function ($event) {
          $event.preventDefault()
          return _vm.submit()
        },
        close: function ($event) {
          $event.preventDefault()
          return _vm.close()
        },
        cancel: function ($event) {
          $event.preventDefault()
          return _vm.close()
        },
      },
      model: {
        value: _vm.showMainTopFixManage,
        callback: function ($$v) {
          _vm.showMainTopFixManage = $$v
        },
        expression: "showMainTopFixManage",
      },
    },
    [
      _c(
        "b-row",
        { staticClass: "mt-1" },
        [
          _c(
            "b-list-group",
            [
              _c(
                "draggable",
                {
                  staticClass: "list-group list-group-flush cursor-move",
                  attrs: { tag: "ul", handle: ".draggable-task-handle" },
                  model: {
                    value: _vm.fixedItems,
                    callback: function ($$v) {
                      _vm.fixedItems = $$v
                    },
                    expression: "fixedItems",
                  },
                },
                [
                  _c(
                    "transition-group",
                    { attrs: { type: "transition", name: "flip-list" } },
                    _vm._l(_vm.fixedItems, function (fixItem, index) {
                      return _c(
                        "b-list-group-item",
                        {
                          key: fixItem.contentType + "-" + fixItem.contentId,
                          attrs: { tag: "li" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "d-flex" },
                            [
                              _c("b-col", [_vm._v(_vm._s(index + 1))]),
                              _c("b-col", [
                                _vm._v(_vm._s(fixItem.contentTypeName)),
                              ]),
                              _c("b-col", [_vm._v(_vm._s(fixItem.contentId))]),
                              _c("b-col", [_vm._v(_vm._s(fixItem.clientName))]),
                              _c("b-col", [
                                _vm._v(_vm._s(fixItem.contentTitle)),
                              ]),
                              _c("b-col", [_vm._v(_vm._s(fixItem.period))]),
                              _c("b-col", [
                                _vm._v(_vm._s(fixItem.postStatusName)),
                              ]),
                              _c("feather-icon", {
                                staticClass: "draggable-task-handle d-inline",
                                attrs: { icon: "MoreVerticalIcon" },
                              }),
                            ],
                            1
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }